import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { useMount } from "react-use";
import { getParentInfo } from "../../api";
import { useState } from "react";

const ParentInfoPage = () => {
  const queryClient = useQueryClient();
  const { key } = useParams();
  const [obj, setObj] = useState(null);

  useMount(async () => {
    const result = await queryClient.fetchQuery([`parents/${key}`], {
      queryFn: () => getParentInfo(key),
    });
    if (result.result) {
      const { data } = result;
      const {
        children_name: name,
        key: parent_key,
        registration: { lecture_id, student_id },
        quiz,
      } = data;
      setObj({ name, parent_key, student_id, lecture_id, quiz });
    }
  });
  return (
    <div
      className="hero min-h-screen"
      style={{
        backgroundImage: `url("/main_bg.jpeg")`,
      }}
    >
      <div className="hero-overlay bg-opacity-70"></div>
      {obj && (
        <div className="hero-content text-center text-neutral-content flex flex-col">
          <h1 className="mb-5 text-5xl font-bold text-yellow-400">{`${obj.name} 학생 학부모님`}</h1>
          <div className="w-full flex flex-row flex-wrap gap-3 justify-center">
            <div className="card w-96 bg-zinc-800 text-zinc-50">
              <div className="card-body items-center text-center">
                <h2 className="card-title">설문</h2>
                <div className="card-actions justify-center">
                  <button
                    className="btn btn-accent btn-wide"
                    onClick={() =>
                      window.open(
                        `/survey/response/${obj.lecture_id}?target=parent`,
                        "_blank"
                      )
                    }
                  >
                    설문 응답
                  </button>
                </div>
              </div>
            </div>
            <div className="card w-96 bg-zinc-800 text-zinc-50">
              <div className="card-body items-center text-center">
                <h2 className="card-title">리포트</h2>
                <div className="card-actions justify-center">
                  <button
                    className="btn btn-accent btn-wide"
                    onClick={() =>
                      window.open(
                        `/parent/report?lecture_id=${obj.lecture_id}&parent_key=${obj.parent_key}`,
                        "_blank"
                      )
                    }
                  >
                    리포트 조회
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParentInfoPage;
